import { render, staticRenderFns } from "./GSGNFTContentCN.vue?vue&type=template&id=197df602&scoped=true"
import script from "./GSGNFTContentCN.vue?vue&type=script&lang=js"
export * from "./GSGNFTContentCN.vue?vue&type=script&lang=js"
import style0 from "./GSGNFTContentCN.vue?vue&type=style&index=0&id=197df602&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "197df602",
  null
  
)

export default component.exports